
import './CSS/ServicesGrid.css';

const offersGrid = ({ service }) => {

  return (
    <section className="offers-section">
      <div className="container">
        <div className="offers-header">
          <h2 className="offers-title">
            What <span className="text-primary">We Offer</span>
          </h2>
          <p className="offers-description">
            {service.offer_description}
          </p>
        </div>

        <div className="offers-grid">
          {service.offers.map((offer, index) => {
            return (<div key={index} className="offer-card">
              <div className="offer-image">
                <img src={offer['image']} alt={offer.title} />
              </div>
              <div className="offer-content" style={{ padding: '24px' }}>
                <h3 className="offer-title">{offer['title']}</h3>
                <p className="offer-description">{offer['description']}</p>
              </div>
            </div>)
          })}
        </div>
      </div>
    </section>
  );
};

export default offersGrid;
